export enum ModuleEnums {
  HOME = 0,
  PROFILE = 1,
  WAREHOUSE = 1150,
  PROVIDERS = 1200,
  TRANSFERS = 1750,
  CASH_FLOW = 12100,
  MY_CASH_FLOW = 12002,
  CATEGORIZATION = 6100,
  USERS_PERMISSIONS = 1450,
}

export const ModuleLinkEnums: Record<ModuleEnums, string> = {
  [ModuleEnums.HOME]: '/home',
  [ModuleEnums.PROFILE]: '/profile',
  [ModuleEnums.WAREHOUSE]: '/warehouses',
  [ModuleEnums.PROVIDERS]: '/suppliers',
  [ModuleEnums.TRANSFERS]: '/transfers',
  [ModuleEnums.CASH_FLOW]: '/accounts-and-banks/cash-flow',
  [ModuleEnums.MY_CASH_FLOW]: '/my-cash-flow',
  [ModuleEnums.CATEGORIZATION]: '/categorization',
  [ModuleEnums.USERS_PERMISSIONS]: '/users-permissions',
}
